// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__16NmO","errorLogs":"styles_errorLogs__j8MJM"};